var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-page"},[_c('iframe',{attrs:{"title":"Panduan Lengkap Medhop","src":"/guide/index.html","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }